// extracted by mini-css-extract-plugin
export default {"popupWrapper":"Popup_popupWrapper__LnOzU"};